import { VPSGravityType, TempType } from './Settings'
import CTPL from './CTPL';
import { RoundValueASTM } from './FuelMath';

export class GravityConversionService {


	static ConvertGravity(config) {
		;
		let baseTemperature, baseTemperatureUnit, basePressure, newGravity, AlternateGravityValue;
		let basePressureUnit=1;
		let vgt=VPSGravityType;
		let vtt=TempType;
		;
		if (config.ObservedGravityType == vgt.Density) {
			baseTemperature = "15.0"
			baseTemperatureUnit = vtt.celcius;
		}
		else {
			baseTemperature = "60.0";
			baseTemperatureUnit = vtt.farenheit;
		}
		 basePressure = "0.0";
		 //let basePressureUnit = ObservedGravityPressureUnit;
		;
		let toBaseCTPL = new CTPL();

		;
		toBaseCTPL.Commodity = config.Commodity;
		toBaseCTPL.ApplyHydrometerCorrection = config.ApplyHydrometerCorrection;
		toBaseCTPL.ObservedGravityType = config.ObservedGravityType;
		toBaseCTPL.ObservedTemperature = config.ObservedTemperature;
		toBaseCTPL.ObservedTemperatureUnit = config.ObservedTemperatureUnit;
		toBaseCTPL.ObservedGravityValue = config.ObservedGravityValue;
		toBaseCTPL.ObservedPressure = config.ObservedPressure;
		toBaseCTPL.ObservedPressureUnit = config.ObservedPressureUnit;
		toBaseCTPL.BaseTemperature = baseTemperature;
		toBaseCTPL.BaseTemperatureUnit = baseTemperatureUnit;
		toBaseCTPL.BasePressure = basePressure;
		toBaseCTPL.BasePressureUnit = basePressureUnit;
		toBaseCTPL.AlternateTemperature = config.AlternateTemperature;
		toBaseCTPL.AlternateTemperatureUnit = config.AlternateTemperatureUnit;
		toBaseCTPL.AlternatePressure = config.AlternatePressure;
		toBaseCTPL.AlternatePressureUnit = config.AlternatePressureUnit;

		toBaseCTPL.CalculateCTPL();
		//let newGravity;
		if (toBaseCTPL.Exception) {
			return false;
		}
		else {
			if ((config.ObservedTemperature != baseTemperature || config.ObservedTemperatureUnit != baseTemperatureUnit
				|| config.ObservedPressure != basePressure || config.ObservedPressureUnit != basePressureUnit
			) &&
				(
					config.AlternateTemperature == baseTemperature && config.AlternateTemperatureUnit === baseTemperatureUnit &&
					config.AlternatePressure == baseTemperature && config.AlternatePressureUnit == basePressureUnit

				)) {
				newGravity = toBaseCTPL.GetBaseGravity(config.AlternateGravityType);

			}
			else {
				newGravity = toBaseCTPL.GetAlternateGravity(config.AlternateGravityType)
			}
			;
			if (newGravity.length > 0) {
				switch (config.AlternateGravityType) {

					case VPSGravityType.Density:
						AlternateGravityValue = RoundValueASTM(newGravity, 0.01)
						break;
					case VPSGravityType.API:
						AlternateGravityValue = RoundValueASTM(newGravity, 0.01)
						break;
					case VPSGravityType.SG:
						AlternateGravityValue = RoundValueASTM(newGravity, 0.0001)
						break;
				}

			}
			else {
				AlternateGravityValue = "";

			}


		}
		;
		return AlternateGravityValue;

	}
}